"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
exports.__esModule = true;
exports.default = void 0;
var _getCommonProps = _interopRequireDefault(require("../../primitives/ButtonPrimitive/common/getCommonProps"));
const getButtonLinkCommonProps = props => {
  if (!props.compact) return (0, _getCommonProps.default)(props);
  return {
    ...(0, _getCommonProps.default)(props),
    padding: "0"
  };
};
var _default = getButtonLinkCommonProps;
exports.default = _default;